import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { Combobox } from "../../../components/ui/combobox";
import { useLanguage } from "../../../contexts/LanguageContext";
import { apptLabels } from "../labels";

interface AppointmentsFiltersDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  employeeFilter: number | "";
  setEmployeeFilter: (value: number | "") => void;
  showDone: boolean;
  setShowDone: (value: boolean | ((prev: boolean) => boolean)) => void;
  showPast: boolean;
  setShowPast: (value: boolean | ((prev: boolean) => boolean)) => void;
  showSaturday: boolean;
  setShowSaturday: (value: boolean | ((prev: boolean) => boolean)) => void;
  showSunday: boolean;
  setShowSunday: (value: boolean | ((prev: boolean) => boolean)) => void;
  showCompanyBlocks: boolean;
  setShowCompanyBlocks: (value: boolean | ((prev: boolean) => boolean)) => void;
  showProfessionalBlocks: boolean;
  setShowProfessionalBlocks: (value: boolean | ((prev: boolean) => boolean)) => void;
  professionalOptions: Array<{ value: string; label: string }>;
}

export function AppointmentsFiltersDialog({
  isOpen,
  onOpenChange,
  employeeFilter,
  setEmployeeFilter,
  showDone,
  setShowDone,
  showPast,
  setShowPast,
  showSaturday,
  setShowSaturday,
  showSunday,
  setShowSunday,
  showCompanyBlocks,
  setShowCompanyBlocks,
  showProfessionalBlocks,
  setShowProfessionalBlocks,
  professionalOptions,
}: AppointmentsFiltersDialogProps) {
  const { lang } = useLanguage();
  const t = apptLabels[lang];

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t.common.filters}</DialogTitle>
        </DialogHeader>
        <div className="p-4 space-y-4">
          <div>
            <label className="text-sm text-neutral-700">{t.common.professional.replace(":", "")}</label>
            <Combobox
              options={professionalOptions}
              value={employeeFilter ? String(employeeFilter) : "all"}
              onChange={(v) => setEmployeeFilter(v === "all" ? "" : Number(v))}
              placeholder={t.common.all}
              searchPlaceholder={t.newPage.comboboxSearch}
              emptyMessage={t.newPage.comboboxEmpty}
              ariaLabel={t.common.professional.replace(":", "")}
              className="mt-1 w-full"
            />
          </div>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={showDone} onChange={() => setShowDone((v) => !v)} />
            {t.common.showDone}
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={showPast} onChange={() => setShowPast((v) => !v)} />
            {t.common.showPastToday}
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={showSaturday} onChange={() => setShowSaturday((v) => !v)} />
            {t.common.showSaturday}
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={showSunday} onChange={() => setShowSunday((v) => !v)} />
            {t.common.showSunday}
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={showCompanyBlocks} onChange={() => setShowCompanyBlocks((v) => !v)} />
            {lang === "pt" ? "Bloqueios Empresa" : "Company Blocks"}
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={showProfessionalBlocks}
              onChange={() => setShowProfessionalBlocks((v) => !v)}
            />
            {lang === "pt" ? "Bloqueios Profissionais" : "Professional Blocks"}
          </label>
        </div>
      </DialogContent>
    </Dialog>
  );
}
